<template>
  <div class="card mb-2" :class="{ 'border-purple' : unread}">
    <div class="card-body">
      <p v-if="!editing" class="card-text whitespace-pre-line">{{ form.comment }}</p>
      <div v-else>
        <form @submit.prevent="save" class="w-100">
          <TextArea
            v-model="form.comment"
            autofocus
            autocapitalize="off"
            rows="3"
            :errors="errors.comment"
            class="w-100"
          />
          <div class="row mt-2">
            <div class="col flex-grow-0 pr-0">
              <LoadingButton
                :loading="saving"
                class="btn btn-primary"
                type="sumbit"
              >
                Save
              </LoadingButton>
            </div>
            <div class="col flex-grow-0 pl-2">
              <button
                @click.prevent="(editing = false), (saving = false)"
                class="btn btn-secondary"
              >
                Cancel
              </button>
            </div>
            <p
              class="col d-flex mb-0 flex-grow-1 align-self-end"
            >
              <small v-if="state.withCounterparty">
                <input
                  type="checkbox"
                  v-model="form.hide_originator"
                  :id="comment.id"
                />
                <label :for="comment.id" class="mb-0">
                  Don't show comment to Originator
                </label>
              </small>
              <small v-else>
                <input
                  type="checkbox"
                  v-model="form.hide_counterparty"
                  :id="comment.id"
                />
                <label :for="comment.id" class="mb-0">
                  Don't show comment to Counterparty
                </label>
              </small>
            </p>
          </div>
        </form>
      </div>

      <div v-if="userMatches(userId) && !editing" class="card-text mt-2">
        <button @click.prevent="editing = true" class="btn btn-sm btn-link p-0">
          Edit
        </button>
      </div>

      <div class="card-text mt-2">
        <div class="float-left">
          <small class="text-muted mr-1">
            Commented by: <strong>{{ name }}</strong>
          </small>
          <small class="text-muted">
            Commented at: <strong>{{ commentData.created_at | localDateTime }}</strong>
          </small>
          <small
            v-if="commentData.created_at !== commentData.updated_at"
            class="text-muted ml-1"
          >
            Edited at: <strong>{{ commentData.updated_at | localDateTime }}</strong>
          </small>
        </div>
        <div class="float-right">
          <small
            v-if="commentData.hide_originator"
            class="text-right text-muted ml-1"
          >
            Hidden from Originator
          </small>
          <small
            v-if="commentData.hide_counterparty"
            class="text-right text-muted ml-1"
          >
            Hidden from Counterparty
          </small>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import helpers from '@/Mixins/helpers';
import contractState from '@/Mixins/contractState';
import LoadingButton from '@/Shared/LoadingButton';
import TextArea from '@/Shared/Inputs/Textarea';

const moment = require('moment');

export default {
  mixins: [helpers, contractState],

  components: {
    LoadingButton,
    TextArea,
  },

  props: {
    comment: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      commentData: this.comment,
      editing: false,
      saving: false,
      errors: {},
      form: {
        comment: this.comment.comment,
        contract_id: this.comment.contract_id,
        contract_block_id: this.comment.contract_block_id,
        hide_originator: this.comment.hide_originator,
        hide_counterparty: this.comment.hide_counterparty,
      },
    };
  },

  computed: {
    unread() {
      const { id } = this.$page.props.auth.user;
      return !this.commentData.read_by.includes(id);
    },

    name() {
      if (this.comment.user) {
        return this.comment.user.fullname;
      }
      return this.comment.counter_party.name;
    },

    userId() {
      if (this.comment.user) {
        return this.comment.user_id;
      }
      return this.comment.counter_party_id;
    },
  },

  methods: {
    save() {
      this.saving = true;
      this.$nextTick(() => {
        window.axios
          .put(`/comment/${this.comment.id}`, this.form)
          .then(({ data }) => {
            this.saving = false;
            this.editing = false;
            this.commentData = data;
          });
      });
    },
  },
};
</script>
